import { render, staticRenderFns } from "./jobDetail.vue?vue&type=template&id=1e4bb26b&scoped=true&"
import script from "./jobDetail.vue?vue&type=script&lang=ts&"
export * from "./jobDetail.vue?vue&type=script&lang=ts&"
import style0 from "./jobDetail.vue?vue&type=style&index=0&id=1e4bb26b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4bb26b",
  null
  
)

export default component.exports